define 'controller/ProductController', ['jquery', 'custom/controller', 'lib/photoswipe', 'lib/photoswipe-ui-default', 'custom/media-query', 'lib/slick', 'lib/kryptonite'], ($, controller, PhotoSwipe, PhotoSwipeUI_Default, mq) ->
  class ProductController

    constructor: (@$el) ->
      @_init()
      @_changeColorSelectionButtonTextOnResize()
      @_scrollToReviewsContainer()

    _init: ->
      $('.main-pictures__carousel').not('.slick-initialized').slick({
        draggable: true,
        infinite: true,
        slidesToShow: 1,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Image précédente" data-test-product-slick-prev></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Image suivante" data-test-product-slick-next></button>',
      })

      $('.main-thumbs').not('.slick-initialized').slick({
        vertical: true,
        draggable: false,
        infinite: true,
        slidesToShow: 3,
        focusOnSelect: true,
        asNavFor: '.main-pictures__carousel',
        prevArrow: '<button type="button" class="slick-prev" aria-label="Image précédente" data-test-product-slick-prev></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Image suivante" data-test-product-slick-next></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              vertical: false,
              draggable: true,
              slidesToShow: 3
            }
          }
        ]
      })
      $('#customer-reviews').on "reviews-loaded", @_showReviewsIfThereAreNoReviews

      @_addToBasket()
      @_changeColorSelectionButtonText()
      @_colorSelect()
      @_initPhotoSwipe()
      @_loadCustomerReviewsScript()
      @_modelTriggerSelect()
      @_setFeaturesVisibility()
      @_toggleFeatures()
      @_toggleOnResize()
      @_toggleReviews()
      @_variationTriggerSelect()
      @_atbStickyButton()
      @_toggleATBStickyButton()
      @_handleSizeAvailabilityOnHover()

    _atbStickyButton: ->
      self = @
      $atbButtonContainer = @$el.find('[data-controller-element=atb-button-container]')
      $stickyButtonWrapper = @$el.find('[data-controller-element=atb-sticky-button-wrapper]')
      $(window).on 'scroll resize', ->
        buttonWrapperHeight = $stickyButtonWrapper.outerHeight()
        self._toggleATBStickyButton($atbButtonContainer, $stickyButtonWrapper, buttonWrapperHeight)

    _toggleATBStickyButton: ($bContainer, $sbWrapper, bwHeight) ->
      if !$bContainer
        $bContainer = @$el.find('[data-controller-element=atb-button-container]')
      if !$sbWrapper
        $sbWrapper = @$el.find('[data-controller-element=atb-sticky-button-wrapper]')
        bwHeight = $sbWrapper.outerHeight()

      if mq.up_to_M
        buttonContainerRect = $bContainer[0].getBoundingClientRect()

        if bwHeight-buttonContainerRect.height>0 && buttonContainerRect.bottom <= $(window).height()
          bwHeight = buttonContainerRect.height

        if buttonContainerRect.top+bwHeight >=0 && buttonContainerRect.bottom <= $(window).height()
          @_resetATBButton($bContainer, $sbWrapper)
        else
          if !$sbWrapper.hasClass('fixed')
            $bContainer.css('min-height', bwHeight+'px')
            $sbWrapper.addClass('fixed')
            $('body').css('padding-bottom',$bContainer.outerHeight()+'px')
            $sbWrapper.find('[data-controller-element=atb-main-button]').attr('type', 'button')
      else
        @_resetATBButton($bContainer, $sbWrapper)

    _resetATBButton: ($bContainer, $sbWrapper) ->
      if $sbWrapper.hasClass('fixed')
        $bContainer.css('min-height', '')
        $sbWrapper.removeClass('fixed')
        $sbWrapper.find('[data-controller-element=atb-main-button]').attr('type', 'submit')
        $('body').css('padding-bottom', '')

    _changeColorSelectionButtonTextOnResize: ->
      self = @
      $(document).ready ->
        $(window).resize ->
          self._changeColorSelectionButtonText()

    _changeColorSelectionButtonText: () ->
      self = this

      if window.innerWidth < 910
        numberOfShownElements = 6
      else if window.innerWidth < 1199
        numberOfShownElements = 7
      else
        numberOfShownElements = 9

      $colors = $(".js-colorSelectionItem")

      if $colors.length <= numberOfShownElements
        $colors.addClass("show-color")
        return

      @_showOnlyNumberOfColors(numberOfShownElements)

      numberOfHiddenElements = $colors.length - numberOfShownElements
      colorSuffix = if numberOfHiddenElements == 1 then ' couleur' else ' couleurs'
      showText = '+ ' + numberOfHiddenElements + colorSuffix
      ariaLabelShow = 'Afficher ' + numberOfHiddenElements + colorSuffix + ' de plus'
      hideText = '- de couleurs'
      ariaLabelHide = 'Afficher moins de couleurs'

      colorSelectionButton = $("#js-colorSelectionShowMore")
      colorSelectionButton.attr('aria-label', ariaLabelShow).text(showText)
      colorSelectionButton.addClass('show-color')
      colorSelectionButton.off "click"
      colorSelectionButton.on "click", ->
        showMore = colorSelectionButton.text() == showText

        if (showMore)
          colorSelectionButton.text(hideText)
          colorSelectionButton.attr({
            'aria-label': ariaLabelHide,
            'aria-expanded': 'true'
          })
          $colors.addClass("show-color")
        else
          colorSelectionButton.text(showText)
          colorSelectionButton.attr({
            'aria-label': ariaLabelShow,
            'aria-expanded': 'false'
          })
          self._showOnlyNumberOfColors(numberOfShownElements)


    _showOnlyNumberOfColors: (numberOfShownElements) ->
      $colors = $('.js-colorSelectionItem')
      isSelectedColorVisible = false

      $colors.removeClass('show-color')

      for i in [0..numberOfShownElements-2]
        $color = $($colors[i])
        $color.addClass('show-color')

        if $color.hasClass('selected')
          isSelectedColorVisible = true

      $lastColor = if isSelectedColorVisible then $($colors[numberOfShownElements - 1]) else $colors.filter('.selected')
      $lastColor.addClass('show-color')

    _initPhotoSwipe: ->

      openPhotoSwipe = (e) ->
        pswpElement = document.querySelectorAll('.pswp')[0]
        # build items array
        items = $('.pswp').data('items')

        # index of the active image
        pswpIndex = 0
        $el = $(e.currentTarget)
        $mainPicturesWrappers = $el.closest("[data-controller-element=main-pictures-wrapper]")
        if $el.attr("src")?
          imgSrc = $el.attr("src")
        else if $mainPicturesWrappers.length > 0
          imgSrc = $mainPicturesWrappers.find(".slick-active img").attr("src")

        if imgSrc?
          pswpIndex = items.findIndex (item) ->
            item.src.split("/p/")[1] == imgSrc.split("/p/")[1]

        options = {
          index: if (pswpIndex == -1) then 0 else pswpIndex,
          captionEl: false,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: false,
          tapToToggleControls: false,
          closeOnScroll: false
        }

        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)

        gallery.listen 'beforeChange', ->
          $('body').addClass("pswp-active")
        gallery.listen 'close', ->
          $('body').removeClass("pswp-active")

        gallery.init()
        return

      $("[data-controller-element=product-main-images] [data-controller-element=product-image]").off()
      $("[data-controller-element=product-main-images] [data-controller-element=product-image]").on 'click',(e) ->
        openPhotoSwipe(e)

    changeToNewUrl = (externalKey, oldKey) ->
      ref = externalKey.toString().substring(0, 6)
      media = externalKey.toString().substring(6, 9)
      if(externalKey.toString().length > 10)
        size = externalKey.toString().substring(10)
        while (size.length < 3)
          size = '0' + size
      else if(oldKey != undefined && oldKey.toString().length > 10)
        size = oldKey.toString().substring(10)
        while (size.length < 3)
          size = '0' + size

      newurl = window.location.href + ''
      newurl = newurl.split('?')[0]
      newurl = newurl.concat('?article=' + ref)
      if(size != undefined)
        newurl = newurl.concat('&size=' + size)
        size = size.replace('^0*', '')
      newurl = newurl.concat('&media=' + media)

      categoryHint = new URL(window.location.href).searchParams.get('cat')
      if categoryHint != null
        newurl = newurl.concat('&cat='+categoryHint)
      history.replaceState({ref: ref + media, size: size}, window.title, newurl)

    refreshMainThumbsSlider = ->
      if $('.main-thumbs__thumb').length > 0
        setTimeout (->
          $('.main-thumbs').slick 'refresh'
          return
        ), 250

    _modelTriggerSelect: ->
      self = @
      # A/B-Test SHOP-1494 ATB sticky button
      $('.js_modelSelection').off()
      $('.js_modelSelection li').on 'click combobox:select-option-with-keyboard', (e) ->
        $el = $(@)
        url = $el.data 'url'
        model = $el.data 'value'
        self._modelSelect(url, model, $el)

      $('input.js-modelSelectionInput').off
      $('input.js-modelSelectionInput').on 'change', (e) ->
        $el = $(@)
        url = $el.data 'url'
        model = $el.val()
        self._modelSelect(url, model, $el)

    _modelSelect: (modelUrl, modelValue, $modelEl) ->
      self = @
      $selectedColorEl = $('.js_productSelection input.js-colorSelectionItem:checked')
      color = $selectedColorEl.data('text')
      $variationInput = $('.js-sizeSelectionInput:checked')
      variation = $selectedColorEl.data('value') || $variationInput.val()
      url = "/p/#{modelValue}/#{modelUrl}?color=#{color}&variation=#{variation}"
      categoryHint = new URL(window.location.href).searchParams.get('cat')
      if categoryHint != null
        url = url.concat('&cat='+categoryHint)

      if $modelEl.closest('#stickyModelModalContentList').length > 0
        isProcessing = true

      $.kryptonite
        url: url
        xhrFields:
          keepShowingLoadingIndicator: if isProcessing then isProcessing else false
        success: ->
          $selectedColorEl = $('.js_productSelection input.js-colorSelectionItem:checked')
          color = $selectedColorEl.data('value')
          variation = color || $variationInput.val()
          changeToNewUrl(color, variation)
          refreshMainThumbsSlider()
          self.$el.data('model-selected', 'true')
          #history.pushState({ref: ref+media, size: size},window.title,newurl)
        complete: ->
          self._init()
          self._keepFocusAfterSelection('model')

          if $modelEl.closest('#stickyModelModalContentList').length > 0
            $('#modalOverlayRight').modal('hide').on 'hidden.bs.modal', () ->
              $sizeOpenEl = $('[data-controller-element=size-open-button]')
              if ($variationInput.val() && $variationInput.data('is-soldout')) || (!$variationInput.val() && $sizeOpenEl.length > 0)
                setTimeout(
                  ->
                    $sizeOpenEl.click()
                , 300
                )
              else
                $('#addToBasketForm').submit()

    _colorSelect: ->
      self = @
      $('.js_productSelection').off()
      $('.js_productSelection').on 'change', 'input.js-colorSelectionItem', (e) ->
        $el = $(@)
        url = $el.data 'url'
        color = $el.data 'value'
        variation = $('.js-sizeSelectionInput:checked').val()
        url = "/p/#{color}/#{url}?variation=#{variation}"
        categoryHint = new URL(window.location.href).searchParams.get('cat')
        if categoryHint != null
          url = url.concat('&cat='+categoryHint)
        $.kryptonite
          url: url
          success: ->
            changeToNewUrl(color, variation)
            refreshMainThumbsSlider()
          complete: ->
            self._init()
            # keep focus on selected color after selection
            self.$el.find(".js_productSelection input.js-colorSelectionItem:checked").trigger( 'focus' )

    _variationTriggerSelect: ->
      self = @
      # A/B-Test SHOP-1494 ATB sticky button
      $('.js_variationSelection').off()
      $('.js_variationSelection li:not(.disabled)').on 'click combobox:select-option-with-keyboard', (e) ->
        $el = $(@)
        url = $el.data 'url'
        variationKey = $el.data 'value'
        self._variationSelect(url, variationKey, $el)

      $previousChecked = $('input.js-sizeSelectionInput:checked')
      $('input.js-sizeSelectionInput').off
      $('input.js-sizeSelectionInput').on 'change', (e) ->
        $el = $(@)
        # when the focus is on a sold out size, we keep the :checked state on the previous selection
        if $el.attr('aria-disabled') == 'true'
          $el.prop 'checked', false
          $previousChecked?.prop 'checked', true
          return

        $previousChecked = $el
        url = $el.data 'url'
        model = $el.val()
        self._variationSelect(url, model, $el)

    _variationSelect: (variationUrl, variationKey, $variationEl) ->
      self = @
      $('.js-sizeSelectionError').addClass('hidden')
      $('.js-sizeSelectionInput').removeAttr('aria-invalid')
      url = "/p/#{variationUrl}#{variationKey}"
      categoryHint = new URL(window.location.href).searchParams.get('cat')
      if categoryHint != null
        url = url.concat('?cat='+categoryHint)

      # close the rightpanel if the selection was in the layer
      if $variationEl.closest('#stickySizeModalContentList').length > 0
        $('#modalOverlayRight').modal('hide')

      $.kryptonite
        url: url
        success: ->
          changeToNewUrl(variationKey, undefined)
          refreshMainThumbsSlider()
          if $variationEl.closest('#stickySizeModalContentList').length > 0
            $("#loading-overlay").addClass("processing")
        complete: ->
          self._init()
          self._keepFocusAfterSelection('size')
          if $variationEl.closest('#stickySizeModalContentList').length > 0
            $('#addToBasketForm').submit()

    _keepFocusAfterSelection: (type) ->
      # Accessibility: keep the focus on the selected size/model so that the user can continue with the keyboard navigation
      # js-modelSelectionInput or js-sizeSelectionInput
      @$el.find("input.js-#{type}SelectionInput:checked").focus()

    _addToBasket: ->
      self = @
      $('#addToBasketForm').off()
      @$el.find('[data-controller-element=atb-main-button]').on 'click', (e) ->
        $button = $(e.currentTarget)
        $modelOpenEl = self.$el.find('[data-controller-element=model-open-button]')
        $sizeOpenEl = self.$el.find('[data-controller-element=size-open-button]')
        $variationInput = $('.js-sizeSelectionInput:checked')
        if $button.attr('type') != "submit"
          if $modelOpenEl.length > 0 && !self.$el.data('model-selected')
            $modelOpenEl.click()
          else if ($variationInput.val() && $variationInput.data('is-soldout')) || !$variationInput.val() && $sizeOpenEl.length > 0
            $sizeOpenEl.click()
          else
            $('#addToBasketForm').submit()

      $('#addToBasketForm').on 'submit', (e) ->
        e.preventDefault()
        if (!$('.js-sizeSelectionInput:checked').val())
          $availableSelection = $('.js-sizeSelectionInput:not([aria-disabled="true"])')
          $availableSelection.attr('aria-invalid', 'true')
          $availableSelection.first().trigger( 'focus' )
          $('.js-sizeSelectionError').removeClass('hidden')
          return false

        $form = $(@)
        $.kryptonite
          url: $form.attr('data-url')
          type: $form.attr('method')
          data: $form.serialize()
          complete: ->
            $('body #loading-overlay').remove()

            if typeof getDataLayerAdd == typeof Function
              dataLayer.push(getDataLayerAdd())
            self._initializeSlickImagesAfterLayerShown()

    _initializeSlickImagesAfterLayerShown: ->
      $('#modalOverlay').on 'shown.bs.modal', (e) ->
        $('.product__carousel').resize()

    _setFeaturesVisibility: ->
      if $('.product').attr('data-accordion-features') == "1"
        $('*[data-accordion="features"]').addClass('active')
        $('*[data-accordion="features"]').parent().next().show()

      if $('.product').attr('data-accordion-description') == "1"
        $('*[data-accordion="description"]').addClass('active')
        $('*[data-accordion="description"]').parent().next().show()

    _toggleFeatures: ->
      $('.product__description-features h2').unbind('click').click ->
        $(this).next().slideToggle()
        $(this).toggleClass('active')
        accordion = $(this).data('accordion')
        if $(this).hasClass('active')
          $('.product').attr('data-accordion-' + accordion, "1")
        else
          $('.product').attr('data-accordion-' + accordion, '')

    #   no longer in use as the ratings are always visible from now on.
    #   Kept it in case, It will be needed again. (renamed product__customer-reviews__inner to product__customer-reviews__element and removed headline in ticket shop-843)
    _toggleReviews: ->
      $('.product__customer-reviews__headline h2').unbind('click').click ->
        $('.product__customer-reviews__inner').slideToggle()
        $(this).toggleClass('active')

    _toggleOnResize: ->
      element = $('.product__customer-reviews__inner')
      if element
        window.onresize = ->
          if window.innerWidth > 767
            $('.product__description-features__inner').addClass('product__description-features__inner--show')
          else
            $('.product__description-features__inner').removeClass('product__description-features__inner--show')
          if element.css("display") is "none"
            $('.product__customer-reviews__headline h2').removeClass('active')
          else
            $('.product__customer-reviews__headline h2').addClass('active')

    _loadCustomerReviewsScript: ->

      if (window.matchMedia('(min-width: 767px)').matches)
        $('.product .product__customer-reviews__inner').hide()

      $('.product .product__short-reviews__link > a').click (e) ->
        e.preventDefault()
        scrollTop = $('.product #customer-reviews').offset().top
        $('.product .product__customer-reviews__inner').show()
        if !$('div').hasClass('active')
          $('.product__customer-reviews__headline h2').addClass('active')

        $('html, body').animate { scrollTop: scrollTop }, 'slow'

      loaded = $('#customer-reviews').data('loaded')
      if loaded == false
        url = $('#customer-reviews').data('url')

        $.ajax({
          url: url,
          cache: true,
          dataType: 'script',
          success: =>
            $('#customer-reviews').data('loaded', true)
            return
        })

        $reviews = $('.product__customer-reviews')

        @_observeDOM $reviews[0], () =>
          @_showReviews()

        # Fallback in case the MutationObserver is not supported by the browser
        setTimeout(() =>
          if $('#netreviews_reviews_tab').length
            @_showReviews()
        , 2000)

      else
        shortReviewsClone = $('#customer-reviews-container').find("[data-controller-element=product-short-reviews]").clone()
        $('[data-controller-element=product-summary]').find("[data-controller-element=product-short-reviews]").replaceWith(shortReviewsClone)

    _showReviews: ->
      $('.product__customer-reviews').removeClass("hide")
      $('.product__short-reviews__link').removeClass("hide")

    _observeDOM: (element, callback) ->
      if !element || element.nodeType != 1
        return

      MutationObserver = window.MutationObserver || window.WebKitMutationObserver

      if !MutationObserver
        return

      new MutationObserver(callback).observe(element, { childList:true, subtree:true })

    _handleSizeAvailabilityOnHover: ->
      @$el.on 'mouseenter', '.js-product-selection-option[data-availability-class]:not(.is-selected, .is-disabled)', (e) ->
        $el = $(e.currentTarget)
        availabilityClass = $el.data('availability-class')
        availabilityLabel = $el.data('availability-label')
        $selectionWrapper = $el.closest('.js-product-selection-wrapper')
        $availabilityHoverLabel = $selectionWrapper.find('.js-availability-hover')

        $selectionWrapper.find('.js-availability-selected').hide()
        $availabilityHoverLabel.attr('data-availability',availabilityClass).text(availabilityLabel).addClass('is-active')

      @$el.on 'mouseleave', '.js-product-selection-option[data-availability-class]:not(.is-selected, .is-disabled)', (e) ->
        $el = $(e.currentTarget)
        $selectionWrapper = $el.closest('.js-product-selection-wrapper')
        $availabilityHoverLabel = $selectionWrapper.find('.js-availability-hover')

        $availabilityHoverLabel.attr('data-availability', '').text('').removeClass('is-active')
        $selectionWrapper.find('.js-availability-selected').show()

    _scrollToReviewsContainer: ->
      @$el.on 'click', '.js-skeepers-product-stars', (e) ->
        $('html, body').animate { scrollTop: $('#customer-reviews-container').offset().top }

    destroy: ->
      @$el.off()
